import { LuBuilding2, LuFileText } from 'react-icons/lu';
import Drawer from '../Drawer/Drawer';
import styles from './MarketplaceItemDrawer.module.css';
import BarnIcon from '../../icons/BarnIcon';

function Stars({ rating }) {
  return (
    <span className={styles.stars}>
      {[1, 2, 3, 4, 5].map(i => (
        <span key={i} style={{ color: i <= Math.round(rating) ? '#f59e0b' : '#d1d5db' }}>★</span>
      ))}
      <span className={styles.ratingText}>{rating.toFixed(1)} • {''}</span>
    </span>
  );
}

export default function MarketplaceItemDrawer({ item, onClose, onPlaceOrder }) {
  if (!item) return null;

  const footer = (
    <button className={styles.placeOrderBtn} onClick={() => onPlaceOrder(item)}>
      Place order
    </button>
  );

  return (
    <Drawer isOpen={!!item} title={item.batchId} onClose={onClose} footer={footer}>
      {/* Seller card */}
      <div className={styles.card}>
        <div className={styles.sellerRow}>
          <div className={styles.sellerIcon}><BarnIcon /></div>
          <div>
            <p className={styles.sellerName}>{item.seller}</p>
            <div className={styles.sellerMeta}>
              <Stars rating={item.sellerRating} />
              <span className={styles.tradesText}>{item.sellerTrades} trades</span>
            </div>
          </div>
        </div>
      </div>

      {/* Commodity + Status */}
      <div className={styles.card}>
        <div className={styles.twoCol}>
          <div>
            <p className={styles.fieldLabel}>Commodity</p>
            <p className={styles.fieldValue}>{item.commodity}</p>
          </div>
          <div>
            <p className={styles.fieldLabel}>Status</p>
            <span className={styles.gradeBadge}>{item.grade}</span>
          </div>
        </div>
      </div>

      {/* Stock information */}
      <div className={styles.card}>
        <p className={styles.cardTitle}>Stock information</p>
        <div className={styles.threeCol}>
          <div>
            <p className={styles.fieldLabel}>Quantity</p>
            <p className={styles.fieldValue}>{item.quantity}</p>
          </div>
          <div>
            <p className={styles.fieldLabel}>Location</p>
            <p className={styles.fieldValue}>{item.location}</p>
          </div>
          <div>
            <p className={styles.fieldLabel}>Amount</p>
            <p className={styles.amountValue}>{item.price}</p>
          </div>
        </div>
      </div>

      {/* Quality specifications */}
      <div className={styles.card}>
        <p className={styles.cardTitle}>Quality specifications</p>
        <div className={styles.threeCol}>
          <div>
            <p className={styles.fieldLabel}>Moisture Content</p>
            <p className={styles.fieldValue}>{item.moisture}</p>
          </div>
          <div>
            <p className={styles.fieldLabel}>Foreign Matter</p>
            <p className={styles.fieldValue}>{item.foreign}</p>
          </div>
          <div>
            <p className={styles.fieldLabel}>Broken/Damaged</p>
            <p className={styles.fieldValue}>{item.broken}</p>
          </div>
        </div>
      </div>

      {/* Certificates */}
      <div className={styles.card}>
        <p className={styles.cardTitle}>Certificates</p>
        {item.certs.map((cert, i) => (
          <div key={i} className={styles.certRow}>
            <LuFileText size={16} color="#9ca3af" />
            <div className={styles.certInfo}>
              <p className={styles.certName}>{cert}</p>
              <p className={styles.certMeta}>2.3 MB • Uploaded</p>
            </div>
            <button className={styles.viewBtn}>View</button>
          </div>
        ))}
      </div>
    </Drawer>
  );
}
